/**
 * Shared date formatting helpers for the ClinikChat web app.
 *
 * Australian healthcare context: patient- and clinician-facing dates
 * MUST render as DD/MM/YYYY (en-AU locale) to avoid ambiguity with the
 * US MM/DD/YYYY format. ISO strings over the wire are handled elsewhere
 * — these helpers are ONLY for UI rendering.
 */

type DateInput = Date | string | number;

function toDate(value: DateInput): Date {
  return typeof value === 'string' || typeof value === 'number' ? new Date(value) : value;
}

/**
 * Format a date as DD/MM/YYYY (Australian locale).
 * Returns an empty string for invalid input so callers can render
 * safely without guarding for NaN themselves.
 */
export function formatDateAU(value: DateInput): string {
  const d = toDate(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-AU');
}

/**
 * Format a date + time using the Australian locale.
 * Example: 24/04/2026, 3:15 pm
 */
export function formatDateTimeAU(value: DateInput): string {
  const d = toDate(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-AU');
}
